import {
    put, takeLatest, call
} from 'redux-saga/effects';
import { axios } from '../client';
import {
    ADD_TO_CART,
    addToCart
} from "../actions/cart";

function* handleAddToCart({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    const messages = {
        phoneNumber: 'We are unable to send a text to this number. Landline and international numbers are not supported. Please enter a valid phone number.'
    };

    if (payload.deliveryMode === 'sms') {

        for (let i = 0; i < payload.phone.length; i++) {

            let phoneNumber = payload.phone[i].replace(/[^0-9]/g, '');
            const message = messages.phoneNumber;

            if (phoneNumber.charAt(0) !== '1') {
                phoneNumber = '1' + phoneNumber;
            }
            if (phoneNumber.length !== 11) {
                yield put(addToCart({message}, {}, true));
            }
            const sessionStorageKeyPrefix = 'giftya_sms_deliverability_status_';

            // Check session storage value if supported.
            let smsDeliverabilityStatus = typeof (Storage) !== 'undefined' ? sessionStorage.getItem(sessionStorageKeyPrefix + phoneNumber) : null;
            if (smsDeliverabilityStatus !== null && parseInt(smsDeliverabilityStatus) !== 1) {
                yield put(addToCart({message}, {}, true));
            }

            try {
                const response = yield call(axios.get, `${window.api_url}/site/twilio/deliverability?phone_number=${phoneNumber}`);
                sessionStorage.setItem(sessionStorageKeyPrefix + phoneNumber, response.data.can_send_sms);

                if (parseInt(response.data.can_send_sms) !== 1) {
                    yield put(addToCart({message}, {}, true));
                }

            } catch (error) {
                sessionStorage.setItem(sessionStorageKeyPrefix + phoneNumber, smsDeliverabilityStatus);
            }
        }
    }

    try {
        yield call(
            axios.post,
            `${window.react_giftya_base_url}/cart/item/add`,
            {
                smsRecipient: payload.phone,
                emailRecipient: payload.email,
                wrapping_image: payload.wrapper,
                merchant_id: payload.merchantId,
                amount: payload.amount,
                image: payload.image,
                video: payload.video,
                message: payload.message,
                date: payload.date,
                deliveryMode: payload.deliveryMode,
                regift: payload.regift,
                regift_gift_id: payload.regiftGiftId
            }
        );

        yield put(addToCart({
            addToCartSuccess: true
        }, {'sent': true}));

    } catch (error) {
        yield put(addToCart(error, {}, true));
    }
}
export function* watchAddToCart() {
    yield takeLatest(ADD_TO_CART, handleAddToCart);
}